import { BiUser, FiType, MdSubject } from '@/components/react-icons/main';
import selectors from '@/redux/selectors/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Panel from '../panel/Panel';
import ArgumentWrapper from './ArgumentWrapper';

export const FlowControlSendEmail = ({ level, handleChange, values = {}, disabled = false }) => {
  const integrationId = useSelector(selectors.activeWorkflowIntegrationId);

  const sendEmail = values?.sendEmail;
  const sendEmailToEndUser = values?.sendEmailToEndUser;
  const emailTo = values?.emailTo;
  const emailSubject = values?.emailSubject;
  const emailBody = values?.emailBody;

  const label = useMemo(() => {
    if (level === 'failure') {
      return 'Send email on failure?';
    }
    if (level === 'success') {
      return 'Send email on success?';
    }
    if (level === 'noResults') {
      return 'Send email on no results?';
    }
    return 'Send email on completion?';
  }, [level]);

  return (
    <>
      <ArgumentWrapper>
        <Panel.Toggle disabled={disabled} label={label} active={sendEmail} onChange={(value) => handleChange('sendEmail', value)} size="xs" />
      </ArgumentWrapper>
      {sendEmail && (
        <>
          {!!integrationId && (
            <ArgumentWrapper>
              <Panel.Toggle disabled={disabled} label="Send email to End User?" description={'If enabled, you can send an email notification to the end user.'} icon={BiUser} active={sendEmailToEndUser} onChange={(value) => handleChange('sendEmailToEndUser', value)} />
            </ArgumentWrapper>
          )}
          <ArgumentWrapper>
            <Panel.LexicalInput disabled={disabled} allowSelfOutput label={sendEmailToEndUser ? 'Additional Tos' : 'To'} icon={BiUser} description={sendEmailToEndUser ? 'Choose email addresses to send to in addition to the end user. Separate emails with commas.' : 'Separate emails with commas'} value={emailTo} onChange={(value) => handleChange('emailTo', value)} />
          </ArgumentWrapper>
          <ArgumentWrapper>
            <Panel.LexicalInput disabled={disabled} allowSelfOutput label="Subject" icon={FiType} description={'Subject of the email'} value={emailSubject} onChange={(value) => handleChange('emailSubject', value)} />
          </ArgumentWrapper>
          <ArgumentWrapper>
            <Panel.LexicalInput disabled={disabled} allowSelfOutput label="Body" icon={MdSubject} description={'Body of the email'} value={emailBody} onChange={(value) => handleChange('emailBody', value)} inputProps={{ style: { maxHeight: 150 } }} />
          </ArgumentWrapper>
        </>
      )}
    </>
  );
};

export default FlowControlSendEmail;
